export const LEGAL_PAGE_NAME = {
  GIFT_CARDS: 'gift-card-terms',
  DATA_PROTECTION: 'data-protection',
  OTHER: 'other-information',
  BUYBACK: 'terms-of-trade-in',
  COOKIES: 'cookies',
  TERMS_SALE: 'terms-of-sale',
  TERMS_USE: 'terms-of-use',
  TERMS_SERVICE: 'terms-of-service',
  TERMS_EXPRESS_REPLACEMENT: 'terms-express-replacement',
  WARRANTY: 'warranty',
  LEGAL_MENTIONS: 'legal-mentions',
}
